module.exports = __webpack_public_path__ + "static/JavierPalencia-0143683693e4d2e09dbf207c21315f5f.jpg";